import { render, staticRenderFns } from "./mouse-pointer.vue?vue&type=template&id=422ecf3b&scoped=true&"
import script from "./mouse-pointer.vue?vue&type=script&lang=js&"
export * from "./mouse-pointer.vue?vue&type=script&lang=js&"
import style0 from "./mouse-pointer.vue?vue&type=style&index=0&id=422ecf3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ecf3b",
  null
  
)

export default component.exports